import { Activity } from "@ofqual/portal-activity-feed";
import { ActionType } from "./ExpansionActivityFeedTypes";

export const buildActions = (
  action: (entity: ActionType | Activity | null) => void,
  disabled: boolean,
  isAdmin: boolean,
  canSendMessage: boolean
) => {
  const note = {
    label: "Add a Note",
    dataTest: "scope-note-activity",
    action: () => action(ActionType.Note),
    disabled,
  };

  const document = {
    label: "Add a Document",
    dataTest: "scope-document-activity",
    action: () => action(ActionType.Document),
    disabled,
  };

  const date = {
    label: "Add a Date",
    dataTest: "scope-date-activity",
    action: () => action(ActionType.Date),
    disabled,
  };

  const additionalEvidence = {
    label: "Request evidence",
    dataTest: "scope-additional-evidence-activity",
    action: () => action(ActionType.AdditionalEvidence),
    disabled,
  };

  const sendMessage = {
    label: "Send Message",
    dataTest: "scope-send-message",
    action: () => action(ActionType.SendMessage),
    disabled,
  };

  let actions: any[] = [];

  if (isAdmin) {
    actions = [additionalEvidence, date, document, note];
  }
  if (canSendMessage) {
    actions = [...actions, sendMessage];
  }
  return actions;
};
